function isIOSDevice() {
  return (
    /iPad|iPhone|iPod/.test(navigator.userAgent) ||
    (navigator.userAgent.includes("Mac") && navigator.maxTouchPoints > 1)
  );
}

function preventIOSInputZoom() {
  if (!isIOSDevice()) return;

  const viewport = document.querySelector('meta[name="viewport"]');
  if (!viewport) return;

  const viewportSettings = viewport.content
    .split(",")
    .map((setting) => setting.trim())
    .filter((setting) => setting && !setting.startsWith("maximum-scale"));

  viewportSettings.push("maximum-scale=1");
  viewport.content = viewportSettings.join(", ");
}

preventIOSInputZoom();
